// extracted by mini-css-extract-plugin
export default {"animatedButton":"AnimatedButton_animatedButton__kj9sB","dance":"AnimatedButton_dance__1wM3a"};